class KpeStorefront {
  constructor(root) {
    this.root = root;
    this.bindTabs();
    this.bindQuickAdd();
    this.bindPersonalize();
    this.bindLookbook();
    this.bindBundle();
  }

  toast(message) {
    let toast = document.querySelector('.kpe-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'kpe-toast';
      document.body.append(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.setTimeout(() => toast.classList.remove('is-visible'), 2200);
  }

  bindTabs() {
    this.root.querySelectorAll('.kpe-tab').forEach(tab => tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      this.root.querySelectorAll('.kpe-tab').forEach(item => item.setAttribute('aria-selected', String(item === tab)));
      this.root.querySelectorAll('.kpe-tab-panel').forEach(panel => panel.hidden = panel.dataset.panel !== target);
    }));
  }

  bindQuickAdd() {
    this.root.querySelectorAll('.kpe-quick-add').forEach(button => button.addEventListener('click', async () => {
      const id = Number(button.dataset.variantId);
      if (!id) return;
      button.disabled = true;
      try {
        await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
        this.toast('Added to your bag ✓');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } finally {
        button.disabled = false;
      }
    }));
  }

  bindPersonalize() {
    const input = this.root.querySelector('.kpe-name-input');
    const preview = this.root.querySelector('.kpe-personalize__name');
    if (input && preview) input.addEventListener('input', () => preview.textContent = input.value.trim().toUpperCase() || input.dataset.fallback);
    this.root.querySelectorAll('.kpe-color').forEach(button => button.addEventListener('click', () => {
      this.root.querySelectorAll('.kpe-color').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      this.root.querySelector('.kpe-personalize__stage')?.style.setProperty('--kpe-preview-color', button.dataset.color);
    }));
    const add = this.root.querySelector('.kpe-personalize-add');
    if (add) add.addEventListener('click', async () => {
      const id = Number(add.dataset.variantId);
      if (!id) return;
      const name = input?.value.trim() || '';
      add.disabled = true;
      try {
        await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1, properties: { Name: name } }] }) });
        this.toast('Your custom case was added ✓');
      } finally {
        add.disabled = false;
      }
    });
  }

  bindLookbook() {
    this.root.querySelectorAll('.kpe-hotspot').forEach(button => button.addEventListener('click', () => {
      const target = button.dataset.look;
      this.root.querySelectorAll('.kpe-look-product').forEach(panel => panel.hidden = panel.id !== target);
    }));
  }

  bindBundle() {
    const checks = [...this.root.querySelectorAll('.kpe-bundle-check')];
    const add = this.root.querySelector('.kpe-bundle-add');
    const total = this.root.querySelector('.kpe-bundle-total-current');
    const original = this.root.querySelector('.kpe-bundle-total-original');
    const discount = Number(this.root.dataset.discount || 0);
    if (!checks.length || !add || !total || !original) return;
    const update = () => {
      const selected = checks.filter(item => item.checked);
      const sum = selected.reduce((value, item) => value + Number(item.dataset.price), 0);
      original.textContent = this.money(sum);
      total.textContent = this.money(sum * (1 - discount / 100));
      add.disabled = selected.length < 2;
    };
    checks.forEach(item => item.addEventListener('change', update));
    add.addEventListener('click', async () => {
      const items = checks.filter(item => item.checked).map(item => ({ id: Number(item.value), quantity: 1 }));
      if (items.length < 2) return;
      add.disabled = true;
      try {
        await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
        this.toast(`Bundle added — ${discount}% saved ✓`);
      } finally {
        add.disabled = false;
      }
    });
    update();
  }

  money(cents) {
    const value = cents / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify.currency?.active || 'USD' }).format(value);
  }
}

const initializeKpeSections = scope => scope.querySelectorAll('.kpe-section').forEach(section => {
  if (!section.dataset.kpeReady) {
    section.dataset.kpeReady = 'true';
    new KpeStorefront(section);
  }
});

document.addEventListener('DOMContentLoaded', () => initializeKpeSections(document));
document.addEventListener('shopify:section:load', event => initializeKpeSections(event.target));

